import { BASE_URL } from "../../Constant";

export const API_GET_ALL_REVIEW: string = `${BASE_URL}/review/getAll`;
export const API_DELETE_REVIEW: string = `${BASE_URL}/review`;

export const REVIEW_STATUS_ACTIVE : number = 1;
export const REVIEW_STATUS_DELETED : number = 10;
export const REVIEW_DELETE_TYPE : string = 'delete';